import { PaneSection, SectionHeader } from 'components/expandable_pane/PaneSection';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const ProfileSectionsLayout = styled.div`
    display: grid;
    gap: 1.6rem;
    align-items: stretch;
    justify-content: stretch;
    grid-template-rows: repeat(auto-fill, 1fr);
    grid-auto-columns: minmax(, auto);
    width: 100%;
    padding-bottom: 1rem;
`;

const ProfileSectionWrapper = styled.div`
    & > :not(:first-child) {
        margin-top: 1.4rem;
    }
`;

const ProfileSectionContent = styled.div`
    display: grid;
    gap: 1.6rem;
    align-items: stretch;
    justify-content: stretch;
    // child width prefers fit-content or a min or 40rem
    grid-template-columns: repeat(auto-fill, minmax(40rem, 1fr));
    grid-auto-rows: minmax(, auto);
    & > * {
        overflow: hidden;
        min-width: 0;
    }
`;

const Header = styled.h3`
    margin: 0;
    font-size: ${tokens.font.sizeLg};
    font-weight: 500;
`;

export type ProfileSectionProps = {
    title: ReactNode;
    children: React.ReactNode;
    className?: string;
};

export function ProfileSection({ title, children, className }: ProfileSectionProps) {
    return (
        <ProfileSectionWrapper className={className}>
            <Header>{title}</Header>
            <ProfileSectionContent>{children}</ProfileSectionContent>
        </ProfileSectionWrapper>
    );
}

const FieldSet = styled.fieldset`
    border: 1px solid ${tokens.border.default};
    border-radius: 8px;
    padding: 1.6rem;
    padding-block: 2rem;
`;

const FieldSetTitle = styled.h4`
    font-size: ${tokens.font.sizeMd};
    font-weight: 500;
    margin: 0;
    margin-bottom: 1rem;
`;

export function ProfileSubSection({ title, children, className }: ProfileSectionProps) {
    return (
        <FieldSet className={className}>
            <FieldSetTitle>{title}</FieldSetTitle>
            {children}
        </FieldSet>
    );
}

const StyledSectionHeader = styled(SectionHeader)`
    margin-top: 0;
    margin-bottom: 0.4rem;
`;

export function ProfileItem({
    label,
    children,
}: {
    label: ReactNode;
    children: React.ReactNode;
}) {
    return (
        <PaneSection
            noSeparator
            label={label}
            SectionHeaderComponent={StyledSectionHeader}
            className="overflow-hidden"
        >
            {children}
        </PaneSection>
    );
}
